export default "__VITE_ASSET__d4747a46__"